import L from 'leaflet'
import {LAND_TYPE} from './mapmanager'

const markericon = {

  // 气泡图标
  resultMarkerIcon(index, type) {
    let color = ''
    if (type === 'red') {
      color = '#F54236'
    } else if (type === 'blue') {
      color = '#4293F4'
    }
    const myIcon = L.divIcon({
      iconSize: [34, 34],
      iconAnchor: [19, 65],
      popupAnchor: [0, 0],
      className: 'caseNamelabel',
      html:
          '<div style="position:relative;">' +
            '<i style="font-style: normal;position:absolute;cursor: pointer;color:#fff;font-size: 18px;left: 50%;transform: translateX(-50%);top: 8px;" ' +
          '">' + index + '</i> ' +
          '<i style="color:' + color + '; font-size: 35px;" class="iconfont icon-dingweiqipao-"></i></div>'
    })
    return myIcon
  },

  // 放大 气泡图标
  maxResultMarkerIcon(index, type) {
    let color = ''
    if (type === 'red') {
      color = '#F54236'
    } else if (type === 'blue') {
      color = '#4293F4'
    }
    const myIcon = L.divIcon({
      iconSize: [41, 42],
      iconAnchor: [20, 72],
      popupAnchor: [0, 0],
      className: 'caseNamelabel',
      html:
          '<div style="position:relative;">' +
            '<i style="font-style: normal;position:absolute;cursor: pointer;color:#fff;font-size: 20px;left: 50%;transform: translateX(-50%);top: 12px;font-style: unset;" ' +
          '">' + index + '</i> ' +
          '<i style="color:' + color + '; font-size: 42px;" class="iconfont icon-dingweiqipao-"></i></div>'
    })
    return myIcon
  },

  // 地块图标
  landMarkerIcon(tyep) {
    let landIcon = ''
    let landIconColor = ''
    let size = ''
    let top = ''
    if (Number(tyep) === LAND_TYPE.land_type_zhuzhai) {
      landIcon = 'icon-zhuzhai'
      landIconColor = '#1ecc85'
      size = '18px'
      top = '4px'
    } else if (Number(tyep) === LAND_TYPE.land_type_shangye) {
      landIcon = 'icon-shangye'
      landIconColor = '#23aee5'
      size = '15px'
      top = '6px'
    } else if (Number(tyep) === LAND_TYPE.land_type_gongye) {
      landIcon = 'icon-gongye'
      landIconColor = '#e99238'
      size = '14px'
      top = '8px'
    } else {
      landIcon = 'icon-qita1'
      landIconColor = '#a26bf6'
      size = '14px'
      top = '8px'
    }
    const myIcon = L.divIcon({
      iconSize: [28, 34],
      iconAnchor: [14, 34],
      popupAnchor: [0, 0],
      className: 'caseNamelabel',
      html:
          '<div style="position:relative;">' +
          '<i style="position:absolute;cursor: pointer;color:#fff;font-size:' + size + ';left: 50%;transform: translateX(-50%);top:' + top + ';" class="iconfont ' +
          landIcon +
          '"></i> ' +
          '<i style="font-size: 28px;color:' + landIconColor + '" class="iconfont icon-dingdian"></i></div>'
    })
    return myIcon
  },

  // 选中地块图标
  maxLandMarkerIcon(tyep) {
    let landIcon = ''
    let landIconColor = ''
    let size = ''
    let top = ''
    if (Number(tyep) === LAND_TYPE.land_type_zhuzhai) {
      landIcon = 'icon-zhuzhai'
      landIconColor = '#1ecc85'
      size = '24px'
      top = '6px'
    } else if (Number(tyep) === LAND_TYPE.land_type_shangye) {
      landIcon = 'icon-shangye'
      landIconColor = '#23aee5'
      size = '22px'
      top = '8px'
    } else if (Number(tyep) === LAND_TYPE.land_type_gongye) {
      landIcon = 'icon-gongye'
      landIconColor = '#e99238'
      size = '22px'
      top = '8px'
    } else {
      landIcon = 'icon-qita1'
      landIconColor = '#a26bf6'
      size = '22px'
      top = '8px'
    }
    const myIcon = L.divIcon({
      iconSize: [42, 47],
      iconAnchor: [21, 47],
      popupAnchor: [0, 0],
      className: 'caseNamelabel',
      html:
        '<div style="position:relative;">' +
        '<i style="position:absolute;cursor: pointer;color:#fff;font-size: ' + size + ';left: 50%;transform: translateX(-50%);top:' + top + ';" class="iconfont ' +
        landIcon +
        '"></i> ' +
        '<i style="font-size: 38px;color:' + landIconColor + '"class="iconfont icon-dingdian"></i></div>'
    })
    return myIcon
  },

  getTooltipDiv(dkmc) {
    const tooltip =
    '<div style="padding: 5px 10px 5px 5px;position:relative;">' +
    '<div style="position:absolute;top: -4px;right:0px;">' +
    '</div>' +
    '<div><span style="display:inline-block;"></span>' +
    '<span style="font-size: 16px;">&nbsp;&nbsp;' +
    dkmc +
    '</span></div>' +
    '</div>'
    return tooltip
  }

}
export {
  markericon
}
